/**
 * Código do `409` que o `contestacao-service` devolve quando a ação chega a uma contestação que
 * venceu sem conclusão (EDD-623). É distinto do `invalid_contestation_transition`: aquele diz "o
 * estado não permite", este diz **por quê** — a Musa não concluiu dentro do prazo.
 */
export const CONTESTATION_EXPIRED_CODE = 'contestation_expired';

/**
 * A recusa é "esta contestação venceu"?
 *
 * Confere o `code` em vez de `instanceof ContestacaoApiError` de propósito: assim funciona com
 * qualquer erro que carregue o código, e não depende da classe estar disponível onde o módulo do
 * cliente é substituído por um dublê.
 */
export function isContestationExpiredError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { code?: unknown }).code === CONTESTATION_EXPIRED_CODE
  );
}
